import debug from 'bows';
import loaderSVG from './util/_loader';

const log = debug('playworks-near-you');

export class PlayworksNearYou {
	constructor(node) {
		this.node = node;
		this.form = this.node.querySelector('.pny-lookup__form');
		this.route = '/wp-json/playworks/near-you';

		this.loadingIcon = document.createElement('div');
		this.loadingIcon.classList.add('pny-lookup__loader');
		this.loadingIcon.insertAdjacentHTML('beforeend', loaderSVG);

		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
			this.submit();
		});

		log(this);
	}

	request(zip) {
		let url = this.route;
		if (zip) {
			url += `?pny-zip=${zip}`;
		}
		const xhr = new XMLHttpRequest();
		this.node.classList.add('pny-lookup--loading');
		this.node.appendChild(this.loadingIcon);

		log('pny', zip, url);
		xhr.open('POST', url);
		xhr.addEventListener('load', (e) => {
			if (xhr.status === 200) {
				const data = JSON.parse(xhr.responseText);
				if (typeof this.callback === 'function') {
					this.callback.call(this, data);
				}
			} else if (typeof this.error === 'function') {
				this.error();
			}
		});
		xhr.send();
	}

	submit() {
		this.request(this.form['pny-zip'].value);
	}

	callback() {
		this.node.classList.remove('pny-lookup--loading');
		if (this.loadingIcon.parentNode) {
			this.loadingIcon.parentNode.removeChild(this.loadingIcon);
		}
	}

	error() {

	}
}

export class PlayworksNearYouNav extends PlayworksNearYou {
	constructor(node) {
		super(node);

		this.instructions = node.querySelector('.pny-lookup__instructions');
		this.localData = sessionStorage.getItem('pny');
		this.runOnce = false;

		if (this.localData) {
			log('sessionStorage', this.localData);
			this.callback(JSON.parse(this.localData));
		} else {
			this.request();
		}
	}

	callback(data) {
		if (this.runOnce && data.url) {
			location.href = data.url;
			return;
		} else if (data.text) {
			sessionStorage.setItem('pny', JSON.stringify(data));
			this.instructions.innerHTML = data.text;
		}

		super.callback();
		this.runOnce = true;
	}
}

export class PlayworksNearYouComponent extends PlayworksNearYou {
	constructor(node) {
		super(node);
	}

	callback(data) {
		log(data);
		if (data.url) {
			location.href = data.url;
		} else {
			this.error();
			super.callback();
		}
	}
}

export default {
	nav: PlayworksNearYouNav,
	component: PlayworksNearYouComponent
};
